import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GlobalComponent } from 'src/app/global/global.component';

import { CommonHttpService } from 'src/app/common.service';
import { GeneralService } from 'src/app/service/general.service';
import { ToastrService } from 'ngx-toastr';
import { CFSSAgecnygrid } from './cfss-agency.service';
import { DataStateChangeEventArgs, FilterSettingsModel, GridComponent } from '@syncfusion/ej2-angular-grids';
import { Observable, Subject } from 'rxjs';
import { GetListBase, WhereCondition } from '../client-parent/client-parent.model';
import { takeUntil } from 'rxjs/operators';
import { CFSSAgencyBO } from './cfss-agency.model';
import { supportService } from '../supportplanner/supportplanner.service';
import { ClientHttpService } from '../client-parent/client-parent.service';

@Component({
  selector: 'app-cfss-agency',
  templateUrl: './cfss-agency.component.html',
  styleUrls: ['./cfss-agency.component.scss']
})
export class CfssAgencyComponent implements OnInit {
  public data: Observable<DataStateChangeEventArgs>;
    initialPage: object;
    ModelType: string;
    
      @ViewChild('grid') public grid: GridComponent;
    filterOptions: FilterSettingsModel;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
 private onDestroy$: Subject<void> = new Subject<void>();
  CFSSAgecnyBO: GetListBase = new GetListBase();
  arraycol: any = [];
    conditionlist: WhereCondition[] = [];  
      cfssSupport: CFSSAgencyBO = new CFSSAgencyBO();
      isSaveorUpdateBoolean:boolean=false;
  stateList: any = [];
languageList:any=[];
        form: FormGroup    
  constructor(fb: FormBuilder, public global: GlobalComponent, @Inject(CFSSAgecnygrid) public gethttp: CFSSAgecnygrid,
      private cdr: ChangeDetectorRef,
      public general: GeneralService, public commonhttp: CommonHttpService,  public ClientService: ClientHttpService,
      public toastrService: ToastrService,public supportser: supportService) {
         this.data = gethttp;
         this.form = fb.group({
         
               name: [' '],
               street: [''],
               state: [''],
               email: ['', Validators.email],
               city: [''],
               zip: ['',],
               phone: ['',],
               fax: ['',],
             })
       }

  ngOnInit(): void {
    this.getCFSSAgencies();
     this.commonhttp.getJSON().pipe(takeUntil(this.onDestroy$)).subscribe(data => {
      this.stateList = data;
    });
    this.getLanguage();
    this.filterOptions = { type: 'Menu' };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
  }
 
  get email() {
    return this.form.get('email');
  }

  get zip() {
    return this.form.get('zip');
  }

  get phone() {
    return this.form.get('phone');
  }
  get fax() {
    return this.form.get('fax');
  }

  getCFSSAgencies() {
      this.gethttp.execute(this.CFSSAgecnyBO);
      let count = 0;
      this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        count = count + 1;
      })
    }

     public onActionComplete(args) {
    this.CFSSAgecnyBO.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
    this.CFSSAgecnyBO.pageitem = this.grid.pagerModule.pagerObj.pageSize;
    this.conditionlist = [];
    if (args.requestType === "filtering" && args.action === "filter") {
      args.columns.forEach(element => {
        this.conditionlist.push(element.properties);
      });
    }

  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  type: string = "";
  public dataStateChange(state): void {
    this.type = (state.action.requestType).toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.CFSSAgecnyBO.orderColumn = state.sorted[0].name;
        this.CFSSAgecnyBO.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      this.CFSSAgecnyBO.field = state.action.currentFilterObject.field;
      this.CFSSAgecnyBO.matchCase = state.action.currentFilterObject.matchCase;
      this.CFSSAgecnyBO.operator = state.action.currentFilterObject.operator;
      this.CFSSAgecnyBO.value = state.action.currentFilterObject.value;
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.CFSSAgecnyBO.field = "name";
        this.CFSSAgecnyBO.matchCase = false;
        this.CFSSAgecnyBO.operator = "startswith";
        this.CFSSAgecnyBO.value = "";
      }
    }
    this.getCFSSAgencies();
    if (this.type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].supportplanner.Pagesize != state.take) {
          this.arraycol[0].supportplanner.Pagesize = state.take

        }

      }
    }
  }

   keyPress(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();

    }

  }

  PhoneFormat(value) {
    if (value == 'phone') {
      this.cfssSupport.phone = this.general.converPhoneGoogleLib(this.cfssSupport.phone);
    }

  }
  PhoneFormat1(value) {
    if (value == 'fax') {
      this.cfssSupport.fax = (this.cfssSupport.fax != '' && this.cfssSupport.fax != undefined && this.cfssSupport.fax != null) ? this.general.converPhoneGoogleLib(this.cfssSupport.fax) : null;
    }
  }
  
    add(type: string) {
      this.isSaveorUpdateBoolean=true;
      if (this.cfssSupport.id == '00000000-0000-0000-0000-000000000000') {
        var saveList: CFSSAgencyBO = JSON.parse(JSON.stringify(this.cfssSupport));
        saveList.agencyId=this.global.globalAgencyId;
        this.supportser.saveCFSSAgency(saveList).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
          this.isSaveorUpdateBoolean=false;
          this.toastrService.success("saved  Successfully", "CFSS agency saved");
          document.getElementById("opencasemanModal1").click();
  
          this.getCFSSAgencies();
        },
          err => {
            this.isSaveorUpdateBoolean=false;
            this.toastrService.error(err.error);
  
          });
      }
      else {
        this.cfssSupport.agencyId=this.global.globalAgencyId;
        this.supportser.saveCFSSAgency(this.cfssSupport).subscribe((data: any) => {
          this.isSaveorUpdateBoolean=false;
          this.toastrService.success("update  Successfully", "CFSS agency Updated ");
          document.getElementById("opencasemanModal1").click();
  
          this.getCFSSAgencies();
        },
          err => {
            this.isSaveorUpdateBoolean=false;
            this.toastrService.error(err.error); 
  
          });
      }
  
  
    }
   editsupport(data) {
    console.log("this.isSaveorUpdateBoolean,this.form,this.cfssSupport",this.isSaveorUpdateBoolean,this.form.invalid,this.cfssSupport.name);
    this.cfssSupport = JSON.parse(JSON.stringify(data));
    this.form.patchValue(data);
  }
  CaseCreateupdate(type: string) {
      if (type == 'new') {
        this.ModelType = 'new';
        this.cfssSupport = new CFSSAgencyBO();
        this.form.reset();
  
  
      }
      else {
  
        this.ModelType = 'edit';
      }
  
    }
  CFSSAgencyId:any;
   Delete() {
    let param = new URLSearchParams()
    param.append("Id", this.CFSSAgencyId)
    this.supportser.delete(param).subscribe((_data: any) => {
      this.toastrService.success("CFSS Agency has been deleted successfully", "CFSS agency deleted");
      document.getElementById("openModal2").click();
      this.getCFSSAgencies();

    },
      err => {
        this.toastrService.error(err.error);
      })

  }
  refresh() {
    this.getCFSSAgencies();
  }
   numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  getLanguage() {
    let params = new URLSearchParams();
    params.append("listCode", "Language");
    this.ClientService.getLOV(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.languageList = data;
    })
  }
}
